export function BrandMark({ size = 36 }: { size?: number }) {
  return (
    <span className="brand-mark" style={{ width: size, height: size }}>
      <img src="/brand/egoesim-mark.svg" alt="EGoeSIM" width={size} height={size} />
    </span>
  );
}
